import { version } from '../../package.json';

export const envvars = {
  apiServer: import.meta.env.VITE_WEB_API_SERVER,
  googleAnalyticsId: import.meta.env.VITE_WEB_GOOGLE_ANALYTICS_ID,
  googleOAuthClientId: import.meta.env.VITE_WEB_GOOGLE_OAUTH_CLIENT_ID,
  newRelicAccountId: import.meta.env.VITE_WEB_NEW_RELIC_ACCOUNT_ID || '',
  newRelicApplicationId: import.meta.env.VITE_WEB_NEW_RELIC_APPLICATION_ID || '',
  newRelicLicenseKey: import.meta.env.VITE_WEB_NEW_RELIC_LICENSE_KEY || '',
  stripeConfirmationUrl: import.meta.env.VITE_WEB_STRIPE_CONFIRMATION_URL,
  stripePublishKey: import.meta.env.VITE_WEB_STRIPE_PUBLISH_KEY,
  urlDocumentation: import.meta.env.VITE_WEB_URL_DOCUMENTATION,
  urlPrivacy: import.meta.env.VITE_WEB_URL_PRIVACY,
  urlToS: import.meta.env.VITE_WEB_URL_TOS,
  urlWebsite: import.meta.env.VITE_WEB_URL_WEBSITE,
  version,
};

export default envvars;
